import React from 'react';
import Contact from '../components/Contact';
import Header from '../components/Header';
import Footer from '../components/Footer';
import SEO from '../components/SEO';
import { agent } from '../config/agents';
import { seoConfig } from '../../seo.config';

export default function ContactPage() {
  return (
    <div className="min-h-screen flex flex-col bg-white">
      <SEO 
        title={seoConfig.contact.title}
        description={seoConfig.contact.description}
        keywords={seoConfig.contact.keywords}
      />
      <Header agent={agent} />
      <Contact agent={agent} />
      <Footer agent={agent} />
    </div>
  );
}